import 'react';
import { ITopUpDetails } from '@/modules/credits/models/top-up-details';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StackStyled } from './details-top-up.styled';
import moment from 'moment';

interface ConfirmCancelPopUpsProps {
  topUps: ITopUpDetails;
}

const DetailsTopUp = ({ topUps }: ConfirmCancelPopUpsProps) => {
  const { t } = useTranslation();

  return (
    <StackStyled>
      <Typography variant="h3">{t('DETAILS')}</Typography>
      <div>
        <Typography variant="caption">{t('TOP_UP_DATE')}</Typography>
        <Typography>{moment(topUps.createdAt).format('DD/MM/YYYY')}</Typography>
      </div>
      <div>
        <Typography variant="caption">{t('ENTERPRISE_NAME')}</Typography>
        <Typography>{topUps.enterprise?.name}</Typography>
      </div>
      <div>
        <Typography variant="caption">{t('REPARTITION_DATE')}</Typography>
        <Typography>
          {topUps.creditsSharing.length > 0
            ? moment(topUps.creditsSharing[0].createdAt).format('DD/MM/YYYY')
            : t('NOT_REPARTED_YET')}
        </Typography>
      </div>
      <div>
        <Typography variant="caption">{t('AMOUNT_€')}</Typography>
        <Typography>{topUps.eurosAmount}</Typography>
      </div>
      <div>
        <Typography variant="caption">{t('CREDIT_FILLED')}</Typography>
        <Typography>{topUps.creditsAmount}</Typography>
      </div>
    </StackStyled>
  );
};

export default DetailsTopUp;
